import axiosInstance from "../../config/axios-config";

async function fetchStatsData(url, setStatsData) {
  try {
    const response = await axiosInstance.get(url);
    const data = await response.data;

    setStatsData(data);
  } catch (err) {
    // console.error(err);
    setStatsData({
      "totalNumberOfProjects": 0,
      "totalNumberOfTeacher": 0,
      "totalNumberOfStudent": 0
    });
  };
}

export { fetchStatsData };